import { Add } from '@mui/icons-material';
import { FormControlLabel, IconButton, Stack, Typography } from '@mui/material';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PriceSuggestionType } from '@retail/products/types';
import { getPriceSuggestionType } from '@retail/products/utils';

interface Props {
  priceType: PriceSuggestionType;
  isAdded?: boolean;
  checkPriceType: (priceType: PriceSuggestionType) => void;
  getPriceTypeValue: (priceType: PriceSuggestionType) => string;
}

export function PriceTypeOption({ priceType, isAdded, checkPriceType, getPriceTypeValue }: Props) {
  const t = usePriceSuggestionTFunction();
  return (
    <FormControlLabel
      control={
        <IconButton
          disabled={isAdded}
          sx={{ p: 0, my: 1, mr: 2 }}
          onClick={() => checkPriceType(priceType)}
        >
          <Add fontSize="small" />
        </IconButton>
      }
      value={priceType}
      label={
        <Stack direction="row" alignItems="center" gap={4}>
          <Typography variant="body1">{getPriceSuggestionType(t, priceType)}</Typography>
          <Typography variant="body2">{getPriceTypeValue(priceType)}</Typography>
        </Stack>
      }
    />
  );
}
